import $ from 'jquery';
import Change from './Change';

function Footer(element, $footprint) {
  this.$element = $(element);
  this.$footprint = $footprint;
  this.register();
  this.update();
  this.ready();
}

Footer.prototype = {
  register() {
    Change.onChange(this.update.bind(this));
  },
  update() {
    this.$footprint.height(this.$element.outerHeight());
  },
  ready() {
    this.$element.addClass('ready');
  },
};

export default Footer;



// WEBPACK FOOTER //
// ./SmartFooter.js